import styled from 'styled-components'
import { layout, space, LayoutProps, SpaceProps } from 'styled-system'

const Icon = styled.img<LayoutProps & SpaceProps>`
  width: 24px;
  height: 24px;
  ${layout};
  ${space};
`

export default Icon
